import React from 'react';

import { IconComponent as Icon  } from 'components/icon';
import { LinkButtonComponent as LinkButton } from 'components/button';
import { CardBackgroundComponent as Card } from '../background';

import bookIcon from 'static/icons/svg/book.svg';
import medicineIcon from 'static/icons/svg/medicine.svg';
import stethoscopeIcon from 'static/icons/svg/magnifying-glass.svg';

const styles = require('./banner-card-component.styles.scss');


export class BannerCardComponent extends React.Component {
  render() {
    return (
      <div className={styles.Banner}>
        <Card className={styles.Card}>
          <Icon src={bookIcon} className={styles.BannerIcon} />
          <h3 className={styles.CardTitle}>Seminare</h3>
          <div className={styles.TextSection}>
            <p>
              Neue Trainingsansätze bei Hund, Katze und Pferd, Ideen für die richtige Auslastung, Integration von Baby und Kind in einen tierischen Haushalt und auch eine Vorbereitung auf den Hundeführerschein sind nur ein Teil meiner Seminare.
            </p>
            <p>
              Hier lernen Sie in entspannter Atmosphäre und in kleinen Gruppen interessantes über Hunde-, Katzen- und Pferdeverhalten.
            </p>
          </div>
          <LinkButton
            className={styles.LinkButton}
            to='/lectures'
          >
            Seminar Plan
          </LinkButton>
        </Card>

        <Card className={styles.Card}>
          <Icon src={medicineIcon} className={styles.BannerIcon} />
          <h3>Therapie</h3>
          <div className={styles.TextSection}>
            <p>
              Spazieren gehen im Wald, der Hund hört aufs Wort und spielt mit seinen Artgenossen. Aber was wenn der Rückruf nicht funktioniert, der Hund unsicher, forsch, aggressiv oder ängstlich ist?
            </p>
            <p>
              Ihre Katze ist ausgeglichen, kuschelt gerne und schnurrt entspannt. Oder zerkratzt Ihre Katze die Tapete, schreit in der Nacht oder uriniert neben die Toilette?
            </p>
          </div>
          <LinkButton
            className={styles.LinkButton}
            to='/therapies'
          >
            Therapie Angebot
          </LinkButton>
        </Card>

        <Card className={styles.Card}>
          <Icon src={stethoscopeIcon} className={styles.BannerIcon} />
          <h3>Konsultation</h3>
          <div className={styles.TextSection}>
            <p>
              Sie suchen fachliche Unterstützung auf dem Gebiet der Tierverhaltensmedizin? Gerne biete ich auch Beratungen in ihrer Praxis an. Mit ausführlicher Anamnese, klinischer Untersuchung und ggf. weiterführenden Laborunteruntersuchungen wird eine Diagnose gestellt.
            </p>
            <p>
              Ein Therapieplan, Begleitung während der Trainingseinheiten und eine schriftliche Rücküberweisung sind selbstverständlich.
            </p>
          </div>
          <LinkButton
            className={styles.LinkButton}
            to='/consultation'
          >
            Mehr Erfahren
          </LinkButton>
        </Card>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/cards/banner-card/banner-card.component.js